import { render, staticRenderFns } from "./step-wrapper.vue?vue&type=template&id=0b3d1337"
import script from "./step-wrapper.vue?vue&type=script&lang=ts"
export * from "./step-wrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports